define('ordersDetailMessagesBodyMessageAttachmentsView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'ordersDetailMessagesBodyMessageAttachmentView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  AttachmentView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'message-attachments-view',
    childView: AttachmentView,

    initialize: function () {
      this.collection = new Backbone.Collection(this.model.get('attachments'));  
    },

    onRender: function () {
      this.setVisibility();
    },

    setVisibility: function () {
      if(this.collection.models.length === 0)
        this.$el.hide();
      else
        this.$el.css('display', 'flex');
    }
  });  
});
